module.exports = __webpack_public_path__ + "img/bg-home-up-bvs.509593f5.png";